var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IconHide(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M.302 9.792C1.856 5.85 5.46 3.017 10 3.017c4.54 0 8.144 2.832 9.698 6.775a.75.75 0 010 .55c-1.554 3.943-5.158 6.775-9.698 6.775-4.541 0-8.144-2.832-9.698-6.775a.75.75 0 010-.55zm1.509.275c1.406 3.285 4.433 5.55 8.189 5.55 3.755 0 6.783-2.265 8.19-5.55-1.407-3.285-4.435-5.55-8.19-5.55-3.756 0-6.783 2.265-8.19 5.55z", clipRule: "evenodd" }),
        React.createElement("path", { fillRule: "evenodd", d: "M10 7.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM6.25 10a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0z", clipRule: "evenodd" }),
        React.createElement("path", { fillRule: "evenodd", d: "M1.47 18.53a.75.75 0 010-1.06l16-16a.75.75 0 111.06 1.06l-16 16a.75.75 0 01-1.06 0z", clipRule: "evenodd" })));
}
export default IconHide;
